/*
 * @Author: Zhouqi
 * @Date: 2026-03-24 14:21:05
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-03-31 19:22:10
 */
import React from 'react';

import LandingLayout from '@/landing/components/LandingLayout';
import ModelLandingPage from '@/landing/model-landing/components/ModelLandingPage';
import config from '@/landing/model-landing/configs/sora-2-pro';

const SITE_URL = 'https://falcocut.ai/models/sora-2-pro';

const Sora2ProPage: React.FC = () => {
  return (
    <LandingLayout
      seo={{
        title: config.seo.title,
        description: config.seo.description,
        url: SITE_URL,
        publishedTime: config.seo.publishedTime,
        modifiedTime: config.seo.modifiedTime,
      }}
    >
      <ModelLandingPage config={config} />
    </LandingLayout>
  );
};

export default Sora2ProPage;
